import React, { Component } from 'react';
import { Layout } from './components/Layout'
import AuthPage from './components/AuthPage'
import { withRouter } from "react-router-dom";
import ToS from './components/ToS';
import $ from 'jquery';
import { clearPickerToken } from './components/auth/pickerAuth';
//window.$ = $;
//window.jQuery = $;
class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = { name: "", picUrl: "", accNum: "", auth: false, agreeToS: true, attemptToS: false, driveId: null, googleAccessToken: null };
        this.getUserInfo = this.getUserInfo.bind(this);
        this.showBusy = this.showBusy.bind(this);
        this.tosDecListener = this.tosDecListener.bind(this);
    }
    setGoogleAccessToken = (token) => {
        //console.log("[App] Storing Google access token");
        localStorage.setItem("googleAccessToken", token);
        localStorage.setItem("googleAccessToken_exp", Date.now() + 3500 * 1000); // ~58 min
        this.setState({ googleAccessToken: token });
    };

    handleLogout = () => {
        clearPickerToken();
        //console.log("picker token cleared");
        localStorage.removeItem('googleAccessToken');
        localStorage.removeItem('googleAccessToken_exp');
        this.setState({ auth: false });
    };

    getUserInfo = async () => {
        let resp = await fetch('api/auth/checkprofile', {
            method: 'GET',
            credentials: 'same-origin'
        });

        if (resp.status === 200) {
            let jdata = await resp.json();
            //console.log("App googleAuthInvalid:", jdata.googleAuthInvalid);

            this.setState({
                name: jdata.name,
                picUrl: jdata.picUrl,
                accNum: jdata.accNum,
                auth: true,
                driveId: jdata.driveId,
                googleAuthInvalid: jdata.googleAuthInvalid === true,
                agreeToS: jdata.agreeToS
            });

            if (!jdata.agreeToS) {
                $('#tosModal').on('hide.bs.modal', this.tosDecListener);
                $('#tosModal').modal('show');
                this.setState({ attemptToS: true });
            }
        }
        else if (resp.status === 400) {
            await fetch('api/auth/signout', {
                method: 'POST',
                credentials: 'same-origin'
            });

            this.handleLogout();
            window.location.reload(false);
        }
        else {
            this.setState({ auth: false });
        }
    };

    componentDidMount() {
        const token = localStorage.getItem("googleAccessToken");
        const exp = localStorage.getItem("googleAccessToken_exp");

        if (token && exp && Date.now() < parseInt(exp, 10)) {
            //console.log("[App] Restored Google token from localStorage");
            this.setState({ googleAccessToken: token });
        } else {
            localStorage.removeItem("googleAccessToken");
            localStorage.removeItem("googleAccessToken_exp");
        }

        const isWwwSubdomain = window.location.hostname.startsWith('www.');
        if (isWwwSubdomain) {
            window.location.href = window.location.href.replace('www.', '');
        }

        (async () => { this.getUserInfo(); })();
    }

    showBusy = (b) => {
        if (b) $('#busyModal').modal("show");
        else $('#busyModal').modal("hide");
    };

    tosAcc = async () => {
        var data = { accNum: this.state.accNum };
        const resp = await fetch('api/auth/accepttos', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        });
        if (resp.status === 200) {
            await this.setState({ agreeToS: true });
            $('#tosModal').modal('hide');
        }
    };

    tosDecListener = () => {
        if (!this.state.agreeToS && this.state.attemptToS) {
            window.location.replace(window.location.origin + "/home");
        }
    };

    setGoogleAuthInvalid = (val) => {
        this.setState({ googleAuthInvalid: val });
    };

        render() {

            const authprops = this.state;
            const tosText = <ToS />;
            return (
                <div>
                    {!this.state.auth ? <AuthPage {...this.props} getUserInfo={this.getUserInfo}></AuthPage> :
                        <Layout {...authprops} refreshUser={this.getUserInfo} showBusy={this.showBusy} setGoogleAuthInvalid={this.setGoogleAuthInvalid} onLogout={this.handleLogout}
                            googleAccessToken={this.state.googleAccessToken}
                            setGoogleAccessToken={this.setGoogleAccessToken}>
                        </Layout>
                    }

                    <div className="modal fade" id="tosModal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">gstitch</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {tosText}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" onClick={this.tosAcc}>Agree</button>
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" >Decline</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="busyModal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">

                                <div className="modal-body">
                                    <div className="">  <img src="/img/gstitch-spinner.svg" alt="" /> Working... </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            );
        }

    }
    export default withRouter(App)